import type { IMedcenter } from '@/entities/medcenter/model/types';

interface MedcenterSortProps {
  hasDiscount: boolean;
  hasOnlineBooking: boolean;
  hasPhones: boolean;
}

function getGroup({ hasDiscount, hasOnlineBooking, hasPhones }: MedcenterSortProps): number {
  if (hasDiscount && hasOnlineBooking && hasPhones) return 1;
  if (hasDiscount && hasOnlineBooking) return 2;
  if (hasDiscount && hasPhones) return 3;
  if (hasOnlineBooking && hasPhones) return 4;
  if (hasOnlineBooking) return 5;
  if (hasPhones) return 6;

  return 7;
}

export function sortMedcenters(a: IMedcenter, b: IMedcenter): number {
  const hasDiscountA =
    a.appointments.primary.priceWithDiscount !== null ||
    a.appointments.secondary.priceWithDiscount !== null ||
    a.appointments.online.priceWithDiscount !== null;

  const hasDiscountB =
    b.appointments.primary.priceWithDiscount !== null ||
    b.appointments.secondary.priceWithDiscount !== null ||
    b.appointments.online.priceWithDiscount !== null;

  const groupA = getGroup({
    hasDiscount: hasDiscountA,
    hasOnlineBooking: a.hasOnlineBooking,
    hasPhones: a.hasPhones,
  });

  const groupB = getGroup({
    hasDiscount: hasDiscountB,
    hasOnlineBooking: b.hasOnlineBooking,
    hasPhones: b.hasPhones,
  });

  return groupA - groupB;
}
